$(document).ready(function () {
    const mobileBreakpoint = 991;
    const scrollOffset = 600;

    $(document).on('click', '.template-boxes--tabs-circle.v2 .section-box--item', function (event) {
        if ($(window).width() > mobileBreakpoint) {
            return;
        }

        event.preventDefault();

        const targetSelector = $(this).attr('href');

        if (!targetSelector || targetSelector.charAt(0) !== '#') {
            return;
        }

        const target = $(targetSelector);

        if (!target.length) {
            return;
        }

        target.data('scroll-after-open', true);
    });

    $(document).on('shown.bs.collapse', '.template-boxes--tabs-circle.v2 .collapse', function () {
        const target = $(this);

        if ($(window).width() > mobileBreakpoint || !target.data('scroll-after-open')) {
            return;
        }

        target.removeData('scroll-after-open');

        const card = target.closest('.card');

        $('html, body').stop(true).animate({
            scrollTop: Math.max(card.offset().top - scrollOffset, 0)
        }, 400);
    });
});



// WEBPACK FOOTER //
// ./resources/js/modules/tabs-circle-v2.js